import styled from 'styled-components';

export const SwitchForeground = styled.div`
	width: 20px;
	height: 20px;
	border-radius: 100%;
	position: absolute;
	top: 2px;
	cursor: pointer;
`;

interface BGProps {
	readonly value: boolean;
}

export const SwitchForegroundGhost = styled(SwitchForeground)`
	opacity: 0;
`;

export const SwitchBackground = styled.div<BGProps>`
	background: ${({ value }) => (value ? 'var(--orange-50)' : 'var(--background)')};
	width: 56px;
	height: 24px;
	position: relative;
	border-radius: 10px;
	${SwitchForeground} {
		background: ${({ value }) => (value ? 'var(--orange)' : 'var(--shadow-color)')};
		left: ${({ value }) => (value ? '1px' : '35px')};
		color: var(--orange-contrast);
		svg {
			width: 12px;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
		}
	}
	${SwitchForegroundGhost} {
		background: ${({ value }) => (value ? 'var(--shadow-color)' : 'var(--shadow-color)')};
		left: ${({ value }) => (value ? '35px' : '1px')};
	}
	/* &:hover {
		${SwitchForegroundGhost} {
			opacity: 1;
		}
	} */
`;
